import {
  Component,
  OnInit,
  Output,
  ViewChildren,
  QueryList,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { keyCodes } from "src/app/shared/models/key-codes.model";
import {
  ClinicsSearchParams,
  Clinic,
} from "src/app/shared/models/clinic.model";
import { Store } from "@ngrx/store";
import { clinicList } from "src/app/shared/ngrx/ngrx-selectors";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { Select, SelectModule } from "primeng/select";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { FormEnhanceDirective } from "src/app/shared/components/ui/form-enhance.directive";
import { ClearMultiComponent } from "src/app/shared/components/ui/clear-multi.component";

@Component({
  selector: "clinic-filters",
  templateUrl: "./clinic-filters.component.html",
  styleUrls: ["./clinic-filters.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    InputWrapComponent,
    TranslateModule,
    SelectModule,
    FormEnhanceDirective,
    ClearMultiComponent,
  ],
  standalone: true,
})
export class ClinicFiltersComponent implements OnInit {
  @Output() onSearch = new EventEmitter<ClinicsSearchParams>();
  searchParams: ClinicsSearchParams;
  clinicId: string;
  selectedClinic: Clinic;

  get clinicList(): Clinic[] {
    return this.store.selectSignal(clinicList)();
  }

  constructor(private readonly store: Store) { }

  ngOnInit(): void { }

  clearSearch() {
    this.clinicId = "";
    this.selectedClinic = null;
    this.search();
  }

  search() {
    this.searchParams = {
      clinicId: this.clinicId,
      clinic: this.selectedClinic,
    };
    this.onSearch.emit(this.searchParams);
  }

  onKeyPress(e: any) {
    if (e.keyCode == keyCodes.enter) {
      this.search();
    }
  }

  onFieldValueChanged(e: any) {
    this.search();
  }
}
